export const EOC_TESTID_PREFIX = 'eoc';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const eocTestId = (...parts: Array<string | number | null | undefined>): string =>
  [EOC_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const eocRowTestId = (
  base: string,
  identity: string | number | null | undefined,
  suffix?: string
): string | undefined => (testIdSlug(identity) ? eocTestId(base, identity, suffix) : undefined);

export const eocOptionTestId = (
  selectTestId: string | undefined,
  value: string | number | null | undefined
): string | undefined =>
  selectTestId && testIdSlug(value) ? `${selectTestId}-option-${testIdSlug(value)}` : undefined;

export const eocFormTestId = (field: string) => eocTestId('form', field);
